var _linearGradient, _linearGradient2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3314612(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.004 512.004",
    height: 512,
    viewBox: "0 0 512.004 512.004",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.002,
    x2: 256.002,
    y1: 497.004,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b59c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cffac"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.004,
    x2: 256.004,
    y1: 512.004,
    y2: 482.004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3ffe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#f0fff4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m346.004 240.004h-60c-8.284 0-15 6.716-15 15v242h90v-242c0-8.284-6.716-15-15-15zm-120 60h-60c-8.284 0-15 6.716-15 15v182h90v-182c0-8.284-6.716-15-15-15zm-120 60h-60c-8.284 0-15 6.716-15 15v122h90v-122c0-8.284-6.716-15-15-15zm360-180h-60c-8.284 0-15 6.716-15 15v302h90v-302c0-8.284-6.716-15-15-15zm44.422-146.18c-1.834-3.677-5.098-6.441-9.027-7.646l-83.256-25.516c-7.921-2.428-16.31 2.026-18.737 9.946-2.427 7.921 2.026 16.31 9.946 18.737l44.945 13.775-445.391 198.18c-7.569 3.368-10.974 12.234-7.606 19.803 2.486 5.587 7.968 8.906 13.713 8.906 2.037 0 4.108-.417 6.09-1.299l449.77-200.129-17.655 48.688c-2.824 7.788 1.2 16.391 8.988 19.215 7.756 2.813 16.38-1.17 19.215-8.988l29.685-81.862c1.4-3.864 1.155-8.133-.68-11.81z",
    fill: "url(#SVGID_1_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497.004 482.004h-482c-8.284 0-15 6.716-15 15s6.716 15 15 15h482c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "url(#SVGID_2_)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3314612);
export default __webpack_public_path__ + "static/media/3314612.dffdd3cae58f16b89fec87fad7303dd4.svg";
export { ForwardRef as ReactComponent };